import React, { Component } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import BlotFormatter from "quill-blot-formatter";
import { ImageBlot } from './formats/ImageBlot';
import 'react-quill/dist/quill.snow.css';

Quill.register({"modules/blotFormatter": BlotFormatter}, true);
Quill.register({ "formats/image": ImageBlot }, true);

type EditorProps = {
  onChange?: Function;
  value: string;
  className?: string;
};
type EditorState = {
  text: string;
};
class Editor extends Component<EditorProps, EditorState> {
  quillRef: any;
  state = {
    text: '',
  };
  constructor(props: EditorProps) {
    super(props);
    this.state.text = props.value ? props.value : '';
    this.handleChange = this.handleChange.bind(this);
  }

  imageHandler = (image: any, callback: any) => {
    var range = this.quillRef.editor.selection.lastRange;
    var value = prompt('What is the image URL');
    if (value) {
      const editor = this.quillRef.editor;
      editor.insertEmbed(range.index, 'image', value, "user");
    }
  }

  modules = {
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, 4, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image'],
        ['clean'],
      ],
      handlers: {
        'image': this.imageHandler,
      },
    },
    blotFormatter: {},
  };

  formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'html',
    'align',
  ]

  handleChange(value: string) {
    this.setState({ text: value });
    if (this.props.onChange) {
      this.props.onChange(
        value
      );
    }
  }

  render() {
    return (
      <ReactQuill ref={(el: any) => this.quillRef = el} className={this.props.className} defaultValue={this.state.text} theme="snow" modules={this.modules} formats={this.formats} value={this.state.text} onChange={this.handleChange} />
    );
  }
}

export default Editor;